import React, { Component } from "react";
import moment from "moment-timezone";
import ReactPlayer from "react-player";
import { PlayArrow } from "@mui/icons-material";
import { ValidatorForm } from "react-material-ui-form-validator";
import { withRouter } from "../../../withRouter";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";
import {
  GetForTestAndSend_Url,
  GroupList_Url,
  ScheduledSMS_Url,
  SendSmsQuickText_Url,
  SendSmsToGrops_Url,
  SmsActivityList_Url,
} from "../../../provider/ServiceUrl";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import PtsAlert from "../ptsAlert/PtsAlert";
import BackButton from "../buttons/BackButton";
import Utils from "../../../provider/Utils";
// import MessageQuestion from "./MessageQuestion";
import { BUSINESS_DOMAIN, MESSAGE_TYPES } from "../../../provider/Enums";
// import ReminderTimer from "../reminderTimer/ReminderTimer";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import PtsDateTimePicker from "../ptsDateTime/PtsDateTimePicker";
import ActivityContactList from "../activityContacts/ActivityContactList";
import GroupContactsDialog from "../activityContacts/GroupContactsDialog";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import { IconButton } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import VCardDialog from "./VCardDialog";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";

class PreviewAndSend extends Component {
  header = store.getState().header.header;
  reminderTypes = store.getState().staticData.reminderTypes;
  defaultCountry = store.getState().staticData.defaultCountry;
  countryListArray = store.getState().staticData.countryList;
  appuser = store.getState().appUserData.appUserData.appuser;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  organization = store.getState().appUserData?.organizationDetails;
  orgTimeZone = store.getState().appUserData?.organizationDetails?.timezone;
  eventTimeZone = store.getState().businessDomain?.eventTimeZone
  valueIndexMap = new Map();
  breadCrumb = [
    { pageid: "/messages", uiname: "Messages" },
    { pageid: "", uiname: "Preview & Send" },
  ];
  constructor(props) {
    super(props);
    let messageId = props.messageId;
    let messagename = props.messagename;
    let action = props.action;
    let smsVariableList = [];
    if (props.state) {
      action = props.state.action;
      messageId = props.state.messageId;
      smsVariableList = props.state.smsVariableList;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "update")
      )
    ) {
      this.getMessageDetails(messageId);
    }
    this.state = {
      messageId: messageId,
      messageName: messagename,
      smsVariableList: smsVariableList,
      currentIndex: 0,
      messages: [
        "Thank you for your ongoing support of {{Org Name}}.\nTo make your tax-deductible, tap here: {{Payment Link}}\nSTOP to opt-out.",
        "You’re almost there! Complete your donation to help our cause.",
        "Reminder: {{Org Name}} still needs your help today!",
      ],
      copied: false,
      questionItems: [],
      scheduledDateTime: null,
      textMessage: "",
      closingTextMessage: "",
      question: "",
      keyword: "",
      recordActivity: "",
      mmsId: "",
      mmsData: "",
      start: 0,
      introMessage: "",
      amountQuestion: "",
      amountOption1: "",
      amountOption2: "",
      amountOption3: "",
      amountOption4: "",
      donationAmount: "",
      reminderEmail: "",
      reminderMobileNo: "",
      mmsFileName: "",
      event: null,
      donationAmountList: [],
      smsGroupList: [],
      smsGroupsId: [],
      activitieIds: [],
      smsActivityList: [],
      recipientTypeList: [],
      alertEmails: "",
      alertMobiles: "",
      reminderType: Utils.getArrayElement(this.reminderTypes, 0),
      ScheduledToSend: true,
      sendNow: false,
      sendReminder: false,
      avoidRepeatSend: false,
      scheduleErrorMessage: false,
      isPledge: false,
      isReminderTimer: false,
      recipientType: null,
      sendToAllOptins: false,
      sendToAllPendings: false,
      reminderErrorMessage: false,
      open: false,
      render: false,
      playing: false,
      showPreviousMsg: false,
      showAllPreviousMsg: false,
      filterByKeyword: false,
      openTextingTimeWindow: false,
      contact: null,
      sortColumn: "name",
      sortDirection: "asc",
      sortMsgColumn: "messageName",
      sortMsgDirection: "asc",
      assignToGroupName: "",
      mobileNo: this.appuser?.phone !== null ? Utils.phoneNumberFormate(this.appuser.phone) : "",
      mobile: this.appuser?.phone !== null ? this.appuser.phone : "",
      countryCode: this.appuser?.phoneCountrycode !== null ? this.appuser.phoneCountrycode : "+1",
    };
  }

  getSmsGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.setState({
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  getSmsActivityList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(SmsActivityList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsActivityList = output.data.activityList;
          this.setState({
            smsActivityList: smsActivityList,
          });
        } else {
        }
      }
    );
  }

  getMessageDetails(messageId) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: messageId,
      },
    };
    FetchServerData.callPostService(GetForTestAndSend_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsMessage = output.data.smsMessage;
          let recipientTypeList = output.data.recipientTypeList;
          let smsActivityList = output.data.activityList;
          let smsGroupList = output.data.groupList;
          let smsMessageFundRaisingDetails =
            output.data.smsMessage?.smsMessageFundRaising;
          let getPermission = Utils.getRolePermission(output.data.privilegeList);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let questionType = {};

          for (let i = 0; i < smsMessage.smsMessageQuestions.length; i++) {
            if (
              smsMessage.smsMessageQuestions[i]?.questionType?.type === "Pledge"
            ) {
              questionType.type =
                smsMessage.smsMessageQuestions[i]?.questionType?.type;
              this.valueIndexMap.set(i, questionType.type);
            }
          }

          let donationAmountList = [];
          if (
            smsMessageFundRaisingDetails?.amountOption1 !== null &&
            smsMessageFundRaisingDetails?.amountOption1 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption1
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption2 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption2
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption3 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption3
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption4 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption4
            );
          }

          this.setState({
            render: true,
            messageId: smsMessage.id,
            messageName: smsMessage.messageName,
            messageType: smsMessage.messageType,
            keyword: smsMessage.keyword,
            assignToGroupName: smsMessage.assignToGroupName !== null ? smsMessage.assignToGroupName : "",
            textMessage: smsMessage.textMessage,
            activityAlert: smsMessage.activityAlert,
            alertEmails: smsMessage.alertEmails,
            alertMobiles: smsMessage.alertMobiles,
            closingTextMessage: smsMessage.closingMessage,
            questionItems: smsMessage.smsMessageQuestions,
            isPledge: smsMessage?.isPledge,
            // fundraisingGoal: smsMessage?.goalAmount,
            fundraisingGoal: smsMessage?.pledgeDetails?.goalAmount,
            amountQuestion: smsMessageFundRaisingDetails?.amountQuestion,
            introMessage: smsMessageFundRaisingDetails?.introMessage,
            amountOption1: smsMessageFundRaisingDetails?.amountOption1,
            amountOption2: smsMessageFundRaisingDetails?.amountOption2,
            amountOption3: smsMessageFundRaisingDetails?.amountOption3,
            amountOption4: smsMessageFundRaisingDetails?.amountOption4,
            donationAmountList: donationAmountList,
            donnerExperince: smsMessageFundRaisingDetails?.donnerExperince,
            smsMessageFundRaisingId: smsMessageFundRaisingDetails?.id,
            mmsType: smsMessage?.mmsType,
            mmsUrl: smsMessage.mmsInfo?.url,
            mmsFileName: smsMessage.mmsInfo?.filename,
            documentType: smsMessage?.mmsType,
            lastActivity: smsMessage?.lastActivity,
            event: smsMessage?.event,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            // recipientType: Utils.getArrayElement(recipientTypeList, 0),
            recipientTypeList: recipientTypeList,
            smsGroupList: smsGroupList,
            smsActivityList: smsActivityList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  sendSmsToGroupBackend() {
    if (!this.state.sendToAllOptins || !this.state.sendToAllPendings) {
      if (
        this.state.smsGroupsId.length === 0 &&
        this.state.activitieIds.length === 0 &&
        this.state.sendToAllOptins === false &&
        this.state.sendToAllPendings === false
      ) {
        PtsAlert.error("Please select the group");
        return;
      }
    }

    const postObject = {
      header: this.header,
      message: {
        id: this.state.messageId,
      },
      groups: this.state.smsGroupsId,
      activities: this.state.activitieIds,
      avoidRepeatSend: this.state.avoidRepeatSend,
      sendToAllOptins: this.state.sendToAllOptins,
      sendToAllPendings: this.state.sendToAllPendings,
      // recipientType: this.state.recipientType,
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(SendSmsToGrops_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsCredits = output.data.smsCredits;
          store.dispatch(PaginationRowAction.setSendHistoryPaginationState({}));
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            if (smsCredits !== null) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCredits)
              );
            }
            store.dispatch(
              ActiveMenuAction.setActiveChildMenu("/eventSendHistory")
            );
            this.props.navigate("/eventSendHistory");
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            if (smsCredits !== null) {
              store.dispatch(AppUserDataAction.setUsage(smsCredits));
            }
            store.dispatch(
              ActiveMenuAction.setActiveMenu("/dptextSendHistory")
            );
            this.props.navigate("/dptextSendHistory");
          } else {
            if (smsCredits !== null) {
              store.dispatch(AppUserDataAction.setUsage(smsCredits));
            }
            store.dispatch(ActiveMenuAction.setActiveMenu("/sendHistory"));
            this.props.navigate("/sendHistory");
          }
        } else {
        }
      }
    );
  }

  scheduleSendToBackend() {
    // const diffTime = Math.abs(new Date() - this.state.scheduledDateTime);
    // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // const diffTime1 = Math.abs(new Date() - this.state.scheduledDateTime);
    // const diffSecond = Math.ceil(diffTime1 / 1000);
    // if (diffDays > 35 || diffSecond < 900) {
    //   this.setState({
    //     scheduleErrorMessage: !this.state.scheduleErrorMessage,
    //   });
    //   return;
    // }
    if (!this.state.sendToAllOptins || !this.state.sendToAllPendings) {
      if (
        this.state.smsGroupsId.length === 0 &&
        this.state.activitieIds.length === 0 &&
        this.state.sendToAllOptins === false &&
        this.state.sendToAllPendings === false
      ) {
        PtsAlert.error("Please select the group");
        return;
      }
    }

    if (
      this.state.sendReminder &&
      this.state.reminderMobileNo === "" &&
      this.state.reminderEmail === ""
    ) {
      this.setState({
        reminderErrorMessage: true,
      });
      return;
    }

    if (this.state.scheduledDateTime === null) {
      PtsAlert.error("Please select scheduled Date and time");
      return;
    }
    const postObject = {
      header: this.header,
      message: {
        id: this.state.messageId,
      },

      scheduledDateTime: moment(this.state.scheduledDateTime).format(
        "yyyy-MM-DDTHH:mm:ss.SSS"
      ),
      groups: this.state.smsGroupsId,
      activities: this.state.activitieIds,
      avoidRepeatSend: this.state.avoidRepeatSend,
      sendToAllOptins: this.state.sendToAllOptins,
      sendToAllPendings: this.state.sendToAllPendings,
      // recipientType: this.state.recipientType,
      reminder: {
        countryCode: this.state.reminderCountryCode,
        mobile: this.state.reminderMobileNo,
        email: this.state.reminderEmail,
        reminderType: this.state.reminderType,
      },
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(ScheduledSMS_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let smsCredits = output.data.smsCredits;
          store.dispatch(PaginationRowAction.setSheduledSendPaginationState({}));
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            if (smsCredits !== null) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCredits)
              );
            }
            store.dispatch(
              ActiveMenuAction.setActiveChildMenu("/eventScheduledSends")
            );
            this.props.navigate("/eventScheduledSends");
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            if (smsCredits !== null) {
              store.dispatch(AppUserDataAction.setUsage(smsCredits));
            }
            store.dispatch(
              ActiveMenuAction.setActiveMenu("/dptextScheduledSends")
            );
            this.props.navigate("/dptextScheduledSends");
          } else {
            if (smsCredits !== null) {
              store.dispatch(AppUserDataAction.setUsage(smsCredits));
            }
            store.dispatch(ActiveMenuAction.setActiveMenu("/scheduledSends"));
            this.props.navigate("/scheduledSends");
          }
        } else {
        }
      }
    );
  }

  onStatusClicked = (e, item) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
      const updatedList = prevState.recipientTypeList.map((rec) =>
        rec.id === item.id
          ? { ...rec, isactive: isChecked }
          : rec
      );

      return {
        recipientTypeList: updatedList,
        sendToAllOptins: updatedList.find(r => r.type === "AllOptins")?.isactive || false,
        sendToAllPendings: updatedList.find(r => r.type === "AllPending")?.isactive || false,
      };
    });
  };

  onGroupClicked(e, groupId) {
    let smsGroupsId = this.state.smsGroupsId;
    if (e.target.checked) {
      this.setState({
        smsGroupsId: [...smsGroupsId, groupId],
      });
    } else {
      let index = smsGroupsId.indexOf(groupId);
      smsGroupsId.splice(index, 1);
      this.setState({
        smsGroupsId: smsGroupsId,
      });
    }
  }

  onActivityClicked(e, activityId) {
    let activitieId = this.state.activitieIds;
    if (e.target.checked) {
      this.setState({
        activitieIds: [...activitieId, activityId],
      });
    } else {
      let index = activitieId.indexOf(activityId);
      activitieId.splice(index, 1);
      this.setState({
        activitieIds: activitieId,
      });
    }
  }

  // toGroupDetails(data) {
  //   if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
  //     this.props.navigate("/eventGroup", {
  //       state: {
  //         action: "view",
  //         groupId: data.id,
  //         messageId: this.state.messageId,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
  //     this.props.navigate("/dptextGroup", {
  //       state: {
  //         action: "view",
  //         groupId: data.id,
  //         messageId: this.state.messageId,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   } else {
  //     this.props.navigate("/group", {
  //       state: {
  //         action: "view",
  //         groupId: data.id,
  //         messageId: this.state.messageId,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   }
  // }

  avoidRepeatSendMessages(e) {
    this.setState({
      avoidRepeatSend: e.target.checked,
    });
  }

  viewCancel() {
    if (
      Utils.equalsIgnoreCase(this.businessDomain, BUSINESS_DOMAIN.eventText)
    ) {
      this.props.navigate("/eventMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else {
      this.props.navigate("/messages");
    }
  }

  // toActivityDetails(data) {
  //   if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
  //     this.props.navigate("/eventActivityContactList", {
  //       state: {
  //         messageId: data.id,
  //         messageName: data.messageName,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
  //     this.props.navigate("/dptextActivityContactList", {
  //       state: {
  //         messageId: data.id,
  //         messageName: data.messageName,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   } else {
  //     this.props.navigate("/activityContactList", {
  //       state: {
  //         messageId: data.id,
  //         messageName: data.messageName,
  //         pageId: "PreviewAndSend",
  //       },
  //     });
  //   }
  // }
  toActivityDetails(data) {
    let activityData = Object.assign(data, { messageId: this.state.messageId });
    if (
      this.activityContactDialogueRef &&
      this.activityContactDialogueRef.current
    ) {
      this.activityContactDialogueRef.current.showActivityContactList(
        activityData
      );
    }
  }

  toGroupDetails(data) {
    if (this.groupContactDialogueRef && this.groupContactDialogueRef.current) {
      this.groupContactDialogueRef.current.showGroupContactList(data);
    }
  }

  toByStatusDetails(data) {
    if (this.groupContactDialogueRef && this.groupContactDialogueRef.current) {
      if (data?.type === "AllPending") {
        this.groupContactDialogueRef.current.showAllPendingContactList();
      } else {
        this.groupContactDialogueRef.current.showAllOptinContactList();
      }
    }
  }

  handleScheduledToSendChange() {
    this.setState({ ScheduledToSend: true, sendNow: false });
  }
  handleSendNowChange() {
    this.setState({
      ScheduledToSend: false,
      sendNow: true,
      scheduledDateTime: null,
      reminderMobileNo: "",
      reminderEmail: "",
      sendReminder: false,
      scheduleErrorMessage: false,
    });
  }
  handleSendReminderChange(e) {
    this.setState({
      sendReminder: e.target.checked,
      reminderErrorMessage: false,
    });
  }

  handleScheduledDateTimeChange = (data) => {
    if (!data?.dateTime) return;

    const selectedDate = new Date(data.dateTime); // ✅ convert to Date
    const now = new Date();

    const diffTime = Math.abs(selectedDate.getTime() - now.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    this.setState({
      render: true,
      scheduledDateTime: data.dateTime,
      scheduleErrorMessage: diffDays >= 2,
      isReminderTimer: true,
    });
  };

  handleReminderTypeChange(selectedValue) {
    if (selectedValue?.type === "Mobile") {
      this.setState({
        reminderType: selectedValue,
        reminderEmail: "",
      });
    } else if (selectedValue?.type === "Email") {
      this.setState({
        reminderType: selectedValue,
        reminderMobileNo: "",
      });
    } else
      this.setState({
        reminderType: selectedValue,
      });
  }
  handleReminderMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        reminderMobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleReminderEmailChange(e) {
    this.setState({
      reminderEmail: e.target.value,
    });
  }

  isOutsideTextingWindow = () => {
    const startStr = this.organization?.textingWindowStart;
    const endStr = this.organization?.textingWindowEnd;
    const timeZone = this.businessDomain === BUSINESS_DOMAIN.eventText ? this.eventTimeZone?.name : this.orgTimeZone?.name; // e.g. "Asia/Kolkata"

    if (!startStr || !endStr) return false;

    const now = timeZone
      ? new Date(new Date().toLocaleString("en-US", { timeZone }))
      : new Date();

    const [startH, startM, startS] = startStr?.split(":").map(Number);
    const [endH, endM, endS] = endStr?.split(":").map(Number);

    const start = new Date(now);
    start.setHours(startH, startM, startS, 0);

    const end = new Date(now);
    end.setHours(endH, endM, endS, 0);

    if (start <= end) {
      return now < start || now > end;
    }

    return !(now >= start || now <= end);
  };

  isScheduleOutsideTextingWindow = () => {
    const startStr = this.organization?.textingWindowStart;
    const endStr = this.organization?.textingWindowEnd;

    if (!startStr || !endStr) return false;

    const now = new Date(this.state.scheduledDateTime);
    const [startH, startM, startS] = startStr?.split(":").map(Number);
    const [endH, endM, endS] = endStr?.split(":").map(Number);

    const start = new Date(now);
    start.setHours(startH, startM, startS, 0);

    const end = new Date(now);
    end.setHours(endH, endM, endS, 0);

    if (start <= end) {
      return now < start || now > end;
    }

    return !(now >= start || now <= end);
  };

  sendSmsToBackend() {
    const timeZone =
      this.businessDomain === BUSINESS_DOMAIN.eventText
        ? this.eventTimeZone?.name
        : this.orgTimeZone?.name;

    const now = timeZone
      ? new Date(new Date().toLocaleString("en-US", { timeZone }))
      : new Date();

    if (this.state.ScheduledToSend === true) {
      if (this.isScheduleOutsideTextingWindow()) {
        this.setState({
          openTextingTimeWindow: true,
        });
        return;
      }
      this.scheduleSendToBackend();
      return;
    } else {
      if (this.isOutsideTextingWindow()) {
        this.setState({
          openTextingTimeWindow: true,
        });
        return;
      }
    }

    if (this.state.event?.startDate) {
      let eventStart;

      if (timeZone) {
        eventStart = new Date(
          new Date(this.state.event.startDate).toLocaleString("en-US", {
            timeZone,
          })
        );
      } else {
        eventStart = new Date(this.state.event.startDate);
      }

      if (eventStart > now) {
        this.setState({
          open: true,
        });
        return;
      }
    }

    this.sendSmsToGroupBackend();
  }



  // sendSmsToBackend() {
  //   const currentDate = new Date().toISOString();
  //   if (this.state.ScheduledToSend === true) {
  //     this.scheduleSendToBackend();
  //   } else {
  //     if (this.state.event?.startDate > currentDate) {
  //       this.setState({
  //         open: true,
  //       });
  //     } else {
  //       this.sendSmsToGroupBackend();
  //     }
  //   }
  // }

  editMessageDetails(e) {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessage", {
        state: {
          action: "edit",
          messageId: this.state.messageId,
          pageId: "PreviewAndSend",
          eventId: this.businessDomainId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessage", {
        state: {
          action: "edit",
          messageId: this.state.messageId,
          pageId: "PreviewAndSend",
          eventId: this.businessDomainId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    } else {
      this.props.navigate("/message", {
        state: {
          action: "edit",
          messageId: this.state.messageId,
          pageId: "PreviewAndSend",
          eventId: this.businessDomainId,
          smsVariableList: this.state.smsVariableList,
        },
      });
    }
  }

  handleRecipientTypeChange(selectedValue) {
    let sendToAllOptins = false;
    if (selectedValue.type === "AllOptins") {
      sendToAllOptins = true;
    }
    this.setState({
      recipientType: selectedValue,
      sendToAllOptins: sendToAllOptins,
    });
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        mobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  handleReminderCountryChange(phone, country, e, formattedValue) {
    this.setState({
      reminderCountryCode: formattedValue,
    });
  }

  sendQwickTextToBackend() {
    let sendQuickTextMessage = "";
    if (!this.state.mobile || this.state.mobile.trim() === "") {
      PtsAlert.error("Please enter a mobile number.");
      return;
    }
    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      sendQuickTextMessage = this.state.amountQuestion;
    } else if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.interactive
      )
    ) {
      sendQuickTextMessage = Utils.getArrayElement(
        this.state.questionItems,
        0
      )?.question;
    } else {
      sendQuickTextMessage = this.state.textMessage;
    }

    const postObject = {
      header: this.header,
      quickText: {
        textMessage: sendQuickTextMessage,
        mobile: this.state.mobile,
        countryCode: this.state.countryCode,
        event: {
          id: this.businessDomainId,
        },
      },
      smsMessage: {
        id: this.state.messageId,
      },
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(SendSmsQuickText_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.setState({
            mobile: "",
            mobileNo: "",
            countryCode:
              this.defaultCountry !== null
                ? `+${this.defaultCountry?.phoneCode}`
                : "",
          });
          // if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
          //   store.dispatch(
          //     ActiveMenuAction.setActiveChildMenu("/eventSendHistory")
          //   );
          //   this.props.navigate("/eventSendHistory");
          // } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          //   store.dispatch(
          //     ActiveMenuAction.setActiveMenu("/dptextSendHistory")
          //   );
          //   this.props.navigate("/dptextSendHistory");
          // } else {
          //   store.dispatch(ActiveMenuAction.setActiveMenu("/sendHistory"));
          //   this.props.navigate("/sendHistory");
          // }
        } else {
        }
      }
    );
  }

  navigateOrgTimeZone() {
    store.dispatch(SelectedTabAction.setSelectedTab(0));
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings");
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }

  handleNext = () => {
    const updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];

    this.setState((prevState) => ({
      currentIndex: Math.min(
        prevState.currentIndex + 1,
        updatedMessages.length - 1
      ),
    }));
  };

  handlePrev = () => {
    this.setState((prevState) => ({
      currentIndex: Math.max(prevState.currentIndex - 1, 0),
    }));
  };

  onClickShowVCardFile = () => {
    if (this.vCardRef && this.vCardRef.current) {
      this.vCardRef.current.showVCardDetails(
        this.state.contact,
        this.state.messageId
      );
    }
  };

  handlePlay = () => {
    this.setState({ playing: true });
  };

  handlePause = () => {
    this.setState({ playing: false });
  };

  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing });
  };

  togglePreviousMsg = () => {
    this.setState({ showPreviousMsg: !this.state.showPreviousMsg });
  };

  toggleShowAllPreviousMsg = () => {
    this.setState({ showAllPreviousMsg: !this.state.showAllPreviousMsg });
  };

  handleSort(column) {
    const { sortColumn, sortDirection, smsGroupList } = this.state;
    let newDirection = "asc";

    if (sortColumn === column && sortDirection === "asc") {
      newDirection = "desc";
    }

    // Copy array before sorting (to avoid mutating state directly)
    const sortedList = [...smsGroupList].sort((a, b) => {
      const valA = (a[column] || "").toString().toLowerCase();
      const valB = (b[column] || "").toString().toLowerCase();

      if (valA < valB) return newDirection === "asc" ? -1 : 1;
      if (valA > valB) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      smsGroupList: sortedList,
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  handleSortActivityList(column) {
    const { sortMsgColumn, sortMsgDirection, smsActivityList } = this.state;
    let newDirection = "asc";

    if (sortMsgColumn === column && sortMsgDirection === "asc") {
      newDirection = "desc";
    }

    // Copy array before sorting (to avoid mutating state directly)
    const sortedList = [...smsActivityList].sort((a, b) => {
      const valA = (a[column] || "").toString().toLowerCase();
      const valB = (b[column] || "").toString().toLowerCase();

      if (valA < valB) return newDirection === "asc" ? -1 : 1;
      if (valA > valB) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      smsActivityList: sortedList,
      sortMsgColumn: column,
      sortMsgDirection: newDirection,
    });
  }

  isScheduledSendDisabled = () => {
    const {
      scheduledDateTime,
      sendToAllOptins,
      sendToAllPendings,
      smsGroupsId,
      activitieIds,
    } = this.state;

    const isGroupSelected =
      sendToAllOptins ||
      sendToAllPendings ||
      smsGroupsId.length > 0 ||
      activitieIds.length > 0

    return !scheduledDateTime || !isGroupSelected;
  };

  isSendDisabled = () => {
    return (
      this.state.smsGroupsId.length === 0 &&
      this.state.activitieIds.length === 0 &&
      this.state.sendToAllPendings === false &&
      this.state.sendToAllOptins === false
    );
  };

  handleTextingTimeWindowClose() {
    this.setState({
      openTextingTimeWindow: false,
    });
  }

  organizationInfo() {
    this.setState({
      openTextingTimeWindow: false,
    });
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    store.dispatch(SelectedTabAction.setSelectedTab(0));

    this.props.navigate("/settings", {
      state: {
        pageId: "OrgLogo",
        action: "view",
      },
    });
  }

  render() {
    this.activityContactDialogueRef = React.createRef();
    this.groupContactDialogueRef = React.createRef();
    this.vCardRef = React.createRef();
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";

    if (this.state.render === false) {
      return <div />;
    } else {
      let updatedMessages = [
        ...this.state.questionItems,
        {
          question: this.state.closingTextMessage,
          step: this.state.questionItems?.length + 1,
        },
      ];
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            editCallback={Utils.equalsIgnoreCase(this.state.messageType?.type, MESSAGE_TYPES.confirmationText) ? null : this.editMessageDetails.bind(this)}
            getUpdatePermission={this.state.getUpdatePermission}
            backCallback={this.viewCancel.bind(this)}
            domainObject="Preview & Send"
            name="Preview & Send"
          />
          <ActivityContactList
            ref={this.activityContactDialogueRef}
            style={{ float: "right" }}
            onChange={this.getSmsActivityList.bind(this)}
          />
          <GroupContactsDialog
            ref={this.groupContactDialogueRef}
            style={{ float: "right" }}
            onChange={this.getSmsGroupList.bind(this)}
          />
          <VCardDialog ref={this.vCardRef} style={{ float: "right" }} />
          <>
            {Utils.equalsIgnoreCase(this.state.messageType?.type, MESSAGE_TYPES.confirmationText) ?
              <>
                <div
                  className="row m-0"
                  style={{
                    backgroundColor: "#fff",
                    boxShadow:
                      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgb(0 0 0 / 29%), 0 3px 1px -2px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="col-md-12">
                    <div className="row p-3">
                      <div className="col-md-12">
                        <div className="row">
                          <label
                            className="col-sm-2 col-form-label fw-bold ps-0"
                            htmlFor="basic-default-Image"
                            id="assetFormLabel"
                          >
                            Preview/Test
                          </label>
                          <>
                            <div
                              className="col-md-3"
                              style={{ width: "385px" }}
                            >
                              <div className="chat-bubble">
                                {this.state.textMessage}
                              </div>
                              <div
                                className="row"
                                style={{ paddingTop: "45px" }}
                              >
                                <div
                                  className="col-sm-5 m-0 d-flex"
                                  id="givbeeText"
                                  style={{ paddingLeft: "11px" }}
                                >
                                  {enableCountryCode ?
                                    <span className="d-flex">
                                      <PhoneInput
                                        country={this.defaultCountry?.code
                                          ?.toString()
                                          ?.toLowerCase()}
                                        onlyCountries={validCountryCodes}
                                        value={this.state.countryCode}
                                        onChange={(
                                          phone,
                                          country,
                                          e,
                                          formattedValue
                                        ) => {
                                          this.handleCountryChange(
                                            phone,
                                            country,
                                            e,
                                            formattedValue
                                          );
                                        }}
                                        autoFormat
                                        countryCodeEditable={false}
                                        disableCountryGuess={false}
                                        enableSearch={true}
                                        alwaysDefaultMask={true}
                                      />
                                      <input
                                        type="text"
                                        autoFocus={true}
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        style={{ width: "169px" }}
                                        value={this.state.mobileNo}
                                        onChange={this.handleMobileNoChange.bind(
                                          this
                                        )}
                                        validators={["required"]}
                                        errormessages={["This field is required"]}
                                      />
                                    </span>
                                    : <input
                                      type="text"
                                      autoFocus={true}
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      style={{ width: "230px" }}
                                      value={this.state.mobileNo}
                                      onChange={this.handleMobileNoChange.bind(
                                        this
                                      )}
                                      validators={["required"]}
                                      errormessages={["This field is required"]}
                                    />}
                                  <span className="d-flex ms-4">
                                    <Button
                                      id="ptsButton"
                                      variant="contained"
                                      style={{
                                        width: "max-content",
                                        height: "25px",
                                        alignSelf: "center",
                                      }}
                                      type="button"
                                      onClick={(e) =>
                                        this.sendQwickTextToBackend(e)
                                      }
                                    >
                                      Send Test
                                    </Button>{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                          <div className="col-md-6">
                            <div className="row">
                              <label
                                className="col-sm-2 col-form-label fw-bold text-end"
                                htmlFor="basic-default-supplierType"
                                id="assetFormLabel"
                              >
                                Title
                              </label>
                              <div className="col-sm-10" id="givbeeText">
                                <span>{this.state.messageName}</span>
                              </div>
                            </div>
                            <div className="row">
                              <label
                                className="col-sm-2 col-form-label fw-bold text-end"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Type
                              </label>
                              <div className="col-md-10" id="givbeeText">
                                <span>{this.state.messageType?.typeDetail}</span>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row p-2 d-flex">
                  <div className="col-sm-12 ps-1">
                    <BackButton
                      type="button"
                      style={{
                        backgroundColor: "#162c50",
                        color: "#fff",
                      }}
                      variant="contained"
                      onClick={(e) => this.viewCancel()}
                    >
                      Back
                    </BackButton>
                  </div>
                </div>
              </>
              :
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.sendSmsToBackend.bind(this)}
              >
                <div
                  className="row m-0"
                  style={{
                    backgroundColor: "#fff",
                    boxShadow:
                      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgb(0 0 0 / 29%), 0 3px 1px -2px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="col-md-12">
                    <div className="row p-3 pb-0">
                      <div className="col-md-12">
                        <div className="row">
                          <label
                            className="col-sm-2 col-form-label fw-bold ps-0"
                            htmlFor="basic-default-Image"
                            id="assetFormLabel"
                          >
                            Preview/Test
                          </label>
                          {!(
                            Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.interactive
                            ) ||
                            Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.interactivePledge
                            )
                          ) && (
                              <>
                                <div
                                  className="col-md-3"
                                  style={{ width: "385px" }}
                                >
                                  <div className="chat-bubble">
                                    {Utils.equalsIgnoreCase(
                                      this.state.messageType?.type,
                                      MESSAGE_TYPES.fundraising
                                    )
                                      ? this.state.amountQuestion
                                      : this.state.textMessage}
                                  </div>
                                  <div
                                    className="row"
                                    style={{ paddingTop: "45px" }}
                                  >
                                    <div
                                      className="col-sm-5 m-0 d-flex"
                                      id="givbeeText"
                                      style={{ paddingLeft: "11px" }}
                                    >
                                      {enableCountryCode ?
                                        <span className="d-flex">
                                          <PhoneInput
                                            country={this.defaultCountry?.code
                                              ?.toString()
                                              ?.toLowerCase()}
                                            onlyCountries={validCountryCodes}
                                            value={this.state.countryCode}
                                            onChange={(
                                              phone,
                                              country,
                                              e,
                                              formattedValue
                                            ) => {
                                              this.handleCountryChange(
                                                phone,
                                                country,
                                                e,
                                                formattedValue
                                              );
                                            }}
                                            autoFormat
                                            countryCodeEditable={false}
                                            disableCountryGuess={false}
                                            enableSearch={true}
                                            alwaysDefaultMask={true}
                                          />
                                          <input
                                            type="text"
                                            autoFocus={true}
                                            autoComplete="off"
                                            id="multiStepsFirstName"
                                            name="multiStepsFirstName"
                                            className="form-control"
                                            style={{ width: "169px" }}
                                            value={this.state.mobileNo}
                                            onChange={this.handleMobileNoChange.bind(
                                              this
                                            )}
                                            validators={["required"]}
                                            errormessages={["This field is required"]}
                                          />
                                        </span>
                                        : <input
                                          type="text"
                                          autoFocus={true}
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          style={{ width: "230px" }}
                                          value={this.state.mobileNo}
                                          onChange={this.handleMobileNoChange.bind(
                                            this
                                          )}
                                          validators={["required"]}
                                          errormessages={["This field is required"]}
                                        />}
                                      <span className="d-flex ms-4">
                                        <Button
                                          id="ptsButton"
                                          variant="contained"
                                          style={{
                                            width: "max-content",
                                            height: "25px",
                                            alignSelf: "center",
                                          }}
                                          type="button"
                                          onClick={(e) =>
                                            this.sendQwickTextToBackend(e)
                                          }
                                        >
                                          Send Test
                                        </Button>{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          {(Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.interactive
                          ) ||
                            Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.interactivePledge
                            )) && (
                              <>
                                <div className="col-sm-3 mt-2 ps-3" style={{ width: "385px" }}>
                                  <div className="chat-bubble">
                                    <span>
                                      {
                                        updatedMessages[this.state.currentIndex]
                                          ?.question
                                      }
                                    </span>

                                    {this.state.currentIndex <
                                      updatedMessages.length - 1 && (
                                        <IconButton
                                          onClick={this.handleNext}
                                          className="chat-nav-button chat-next"
                                          size="small"
                                        >
                                          <ArrowForward fontSize="small" />
                                        </IconButton>
                                      )}

                                    {this.state.currentIndex > 0 && (
                                      <IconButton
                                        onClick={this.handlePrev}
                                        className="chat-nav-button chat-prev"
                                        size="small"
                                      >
                                        <ArrowBack fontSize="small" />
                                      </IconButton>
                                    )}
                                  </div>
                                  <div
                                    className="row"
                                    style={{ paddingTop: "45px" }}
                                  >
                                    <div
                                      className="col-sm-5 m-0 d-flex"
                                      id="givbeeText"
                                      style={{ paddingLeft: "11px" }}
                                    >
                                      <span className="d-flex">
                                        <PhoneInput
                                          country={this.defaultCountry?.code
                                            ?.toString()
                                            ?.toLowerCase()}
                                          onlyCountries={validCountryCodes}
                                          value={this.state.countryCode}
                                          onChange={(
                                            phone,
                                            country,
                                            e,
                                            formattedValue
                                          ) => {
                                            this.handleCountryChange(
                                              phone,
                                              country,
                                              e,
                                              formattedValue
                                            );
                                          }}
                                          autoFormat
                                          countryCodeEditable={false}
                                          disableCountryGuess={false}
                                          enableSearch={true}
                                          alwaysDefaultMask={true}
                                        />
                                        <input
                                          type="text"
                                          autoFocus={true}
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control"
                                          style={{ width: "169px" }}
                                          value={this.state.mobileNo}
                                          onChange={this.handleMobileNoChange.bind(
                                            this
                                          )}
                                          validators={["required"]}
                                          errormessages={["This field is required"]}
                                        />
                                      </span>
                                      <span className="d-flex ms-4">
                                        <Button
                                          id="ptsButton"
                                          variant="contained"
                                          style={{
                                            width: "max-content",
                                            height: "25px",
                                            alignSelf: "center",
                                          }}
                                          type="button"
                                          onClick={(e) =>
                                            this.sendQwickTextToBackend(e)
                                          }
                                        >
                                          Send Test
                                        </Button>{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                              </>
                            )}
                          <div className="col-md-6">
                            <div className="row">
                              <label
                                className="col-sm-2 col-form-label fw-bold text-end"
                                htmlFor="basic-default-supplierType"
                                id="assetFormLabel"
                              >
                                Title
                              </label>
                              <div className="col-sm-10" id="givbeeText">
                                <span>{this.state.messageName}</span>
                              </div>
                            </div>
                            <div className="row">
                              <label
                                className="col-sm-2 col-form-label fw-bold text-end"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Type
                              </label>
                              <div className="col-md-10" id="givbeeText">
                                <span>{this.state.messageType?.typeDetail}</span>
                              </div>
                            </div>
                            <div className="row align-items-center">
                              <label
                                className="col-sm-2 col-form-label fw-bold text-end"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Keyword
                              </label>

                              <div className="col-sm-3 m-0" id="givbeeText">
                                <span>{this.state.keyword}</span>
                              </div>
                              {this.state.assignToGroupName !== "" ?
                                <>
                                  <label
                                    className="col-sm-2 col-form-label fw-bold text-end p-0"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Group assigned
                                  </label>

                                  <div className="col-sm-5" id="givbeeText">
                                    <span>{this.state.assignToGroupName}</span>
                                  </div>
                                </> :
                                <div className="col-sm-5" id="givbeeText"></div>
                              }
                            </div>
                            {this.state.mmsUrl && (
                              <>
                                {this.state.documentType === "video" && (
                                  <div className="row">
                                    <label
                                      className="col-sm-2 col-form-label fw-bold text-end"
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      Video
                                    </label>
                                    <div
                                      className="col-sm-10 pt-2"
                                      id="givbeeText"
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "fit-content",
                                        }}
                                      >
                                        <ReactPlayer
                                          src={
                                            this.state.mmsUrl
                                              ? this.state.mmsUrl
                                              : ""
                                          }
                                          playing={this.state.playing}
                                          width="100%"
                                          height="185px"
                                          borderRadius="10px"
                                          controls={false} // hide default controls
                                          onClick={this.handlePlayPause}
                                          onEnded={() =>
                                            this.setState({
                                              playing: false,
                                            })
                                          }
                                        />

                                        {/* Show play button only when not playing */}
                                        {!this.state.playing && (
                                          <button
                                            onClick={this.handlePlayPause}
                                            type="button"
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              left: "50%",
                                              transform: "translate(-50%, -50%)",
                                              background: "rgba(0, 0, 0, 0.6)",
                                              border: "none",
                                              borderRadius: "50%",
                                              width: "40px",
                                              height: "40px",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <PlayArrow
                                              style={{
                                                fontSize: 30,
                                                color: "white",
                                              }}
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {(this.state.documentType === null ||
                                  this.state.documentType === "image") && (
                                    <div className="row">
                                      <label
                                        className="col-sm-2 col-form-label fw-bold text-end"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        Image
                                      </label>
                                      <div
                                        className="col-sm-10 pt-2"
                                        id="givbeeText"
                                      >
                                        <img
                                          style={{
                                            width: "auto",
                                            height: "6em",
                                            objectFit: "contain",
                                            objectPosition: "left",
                                            borderRadius: "10px",
                                            marginLeft: "7px",
                                          }}
                                          alt=""
                                          src={
                                            this.state.mmsUrl
                                              ? this.state.mmsUrl
                                              : ""
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                {this.state.documentType === "vCard" && (
                                  <div className="row">
                                    <label
                                      className="col-sm-2 col-form-label fw-bold text-end"
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      vCard
                                    </label>
                                    <div className="col-sm-10" id="givbeeText">
                                      <span
                                        onClick={(e) =>
                                          this.onClickShowVCardFile()
                                        }
                                        className="anchortag"
                                      >
                                        {Utils.truncateString(
                                          this.state.mmsFileName,
                                          20
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.fundraising
                        ) && (
                            <>
                              <div className="row mt-2">
                                <div className="col-md-12 ps-0">
                                  <div className="row">
                                    <label
                                      className="col-sm-2 col-form-label fw-bold"
                                      htmlFor="basic-default-supplierType"
                                      id="assetFormLabel"
                                    >
                                      Donor Experience
                                    </label>
                                    {Utils.equalsIgnoreCase(
                                      this.state.donnerExperince?.name,
                                      "Without Introduction"
                                    ) ? (
                                      <div className="col-sm-10" id="givbeeText">
                                        <span>No Introduction</span>
                                      </div>
                                    ) : (
                                      <div className="col-sm-10" id="givbeeText">
                                        <span>{this.state.introMessage}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12  ps-0">
                                  <div className="row d-flex">
                                    <label
                                      className="col-md-2 col-form-label fw-bold pe-0"
                                      htmlFor="basic-default-supplierType"
                                      id="assetFormLabel"
                                    >
                                      Donation Amounts
                                    </label>
                                    <div className="col-md-10">
                                      <ul
                                        style={{
                                          listStyle: "none",
                                          display: "flex",
                                          padding: "0px",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {this.state.donationAmountList.map(
                                          (amountValue, index) => {
                                            return (
                                              <>
                                                {
                                                  <div className="d-flex">
                                                    <li
                                                      style={{
                                                        alignItems: "center",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "5px",
                                                        padding: "2.5px",
                                                        marginRight: "10px",
                                                        color: "#353538",
                                                      }}
                                                    >
                                                      $
                                                      {Utils.formatWithCommas(
                                                        amountValue
                                                      )}
                                                    </li>
                                                  </div>
                                                }
                                              </>
                                            );
                                          }
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12  ps-0">
                                  <div className="row">
                                    <label
                                      className="col-sm-2 col-form-label fw-bold"
                                      htmlFor="basic-default-supplierType"
                                      id="assetFormLabel"
                                    >
                                      Fundraising Goal
                                    </label>
                                    <div className="col-sm-10" id="givbeeText">
                                      <span>{`$${Utils.formatWithCommas(
                                        this.state.fundraisingGoal
                                      )}`}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                      {this.state.activityAlert?.type !== "Off" && (
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div className="row">
                              <label
                                className="col-sm-2 col-form-label fw-bold ps-0"
                                htmlFor="exampleFormControlTextarea1"
                              >
                                Activity Alerts
                              </label>
                              <div className="col-sm-10" id="givbeeText">
                                {this.state.alertMobiles !== "" &&
                                  this.state.alertMobiles !== null && (
                                    <div className="row d-flex">
                                      <label
                                        className="col-md-1 col-form-label"
                                        htmlFor="exampleFormControlTextarea1"
                                      >
                                        Mobile:
                                      </label>
                                      <div className="col-md-10 align-self-center">
                                        {this.state.alertMobiles}
                                      </div>
                                    </div>
                                  )}
                                {this.state.alertEmails !== "" &&
                                  this.state.alertEmails !== null && (
                                    <div className="row d-flex">
                                      <label
                                        className="col-md-1 col-form-label"
                                        htmlFor="exampleFormControlTextarea1"
                                      >
                                        Email:
                                      </label>
                                      <div className="col-md-10 align-self-center">
                                        {this.state.alertEmails}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {!Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.optIn
                    ) && (
                        <>
                          <hr />
                          <div>
                            <div className="p-3 pt-1">
                              <div className="col-md-12">
                                <div className="row d-flex">
                                  <label
                                    className="col-sm-2 col-form-label fw-bold ps-0"
                                    htmlFor="basic-default-supplierType"
                                    id="assetFormLabel"
                                  >
                                    Select
                                    <p
                                      className="fw-normal ps-0 m-0 pe-4"
                                      htmlFor="basic-default-supplierType"
                                      id="givbeeText"
                                      style={{ fontSize: "12px" }}
                                    >
                                      Messages are sent to selected recipients just once.
                                    </p>
                                  </label>
                                  <div className="col-sm-10">
                                    <div className="row d-flex">
                                      <div className="col-sm-12">
                                        <div className="row d-flex pb-2 pb-2">
                                          <label
                                            className="col-sm-2 col-form-label fw-bold ps-3"
                                            htmlFor="exampleFormControlTextarea1"
                                          >
                                            By Status
                                          </label>
                                          <div className="col-md-10">
                                            <div className="row d-flex pt-1">
                                              {this.state.recipientTypeList?.map(
                                                (item, index) =>
                                                  item.count > 0 ? (
                                                    <li
                                                      className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                      style={{ width: "22em" }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        checked={item.isactive}
                                                        id={`checkboxByStatus-${item.id}`}
                                                        onChange={(e) =>
                                                          this.onStatusClicked(
                                                            e,
                                                            item
                                                          )
                                                        }
                                                        style={{
                                                          alignSelf: "center",
                                                          marginRight: 5,
                                                          marginTop: "1px",
                                                          height: "12px",
                                                          width: "12px",
                                                        }}
                                                      />
                                                      &nbsp;
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow: "ellipsis",
                                                          cursor: "pointer",
                                                          color: item.isactive ? "#337AB7" : "#697a8d",
                                                        }}
                                                        onClick={() =>
                                                          document
                                                            .getElementById(
                                                              `checkboxByStatus-${item.id}`
                                                            )
                                                            .click()
                                                        }
                                                      >
                                                        {item?.description}
                                                      </span>
                                                      <span
                                                        className="ms-2"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: item.isactive ? "#337AB7" : "#697a8d",
                                                          fontWeight: "600",
                                                        }}
                                                        onClick={this.toByStatusDetails.bind(
                                                          this,
                                                          item
                                                        )}
                                                      >
                                                        {"(" + item.count + ")"}
                                                      </span>
                                                    </li>
                                                  ) : (
                                                    <li
                                                      className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                      style={{
                                                        width: "22em",
                                                        color: "#cccccc",
                                                      }}
                                                    >
                                                      <input
                                                        disabled
                                                        type="checkbox"
                                                        checked={item.isactive}
                                                        style={{
                                                          alignSelf: "center",
                                                          marginRight: 5,
                                                          marginTop: "1px",
                                                          height: "12px",
                                                          width: "12px",
                                                        }}
                                                      />
                                                      &nbsp;
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow: "ellipsis",
                                                        }}
                                                      >
                                                        {item?.description}
                                                      </span>
                                                      <span
                                                        className="ms-2"
                                                        style={{
                                                          color: "#cccccc",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {"(" + item.count + ")"}
                                                      </span>
                                                    </li>
                                                  )
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row d-flex">
                                      <div className="col-md-12">
                                        <>
                                          <div
                                            className="row d-flex pt-2 pb-2"
                                            style={{
                                              borderTop: "2px solid #d3d0d0d5",
                                            }}
                                          >
                                            <label
                                              className="col-sm-2 col-form-label fw-bold ps-3"
                                              htmlFor="exampleFormControlTextarea1"
                                            >
                                              <span
                                                className="cursor-pointer"
                                                onClick={() =>
                                                  this.handleSort("name")
                                                }
                                              >
                                                By Group
                                                {this.state.sortColumn === "name" &&
                                                  (this.state.sortDirection ===
                                                    "asc" ? (
                                                    <i
                                                      class="fa fa-long-arrow-up ps-1"
                                                      aria-hidden="true"
                                                    ></i>
                                                  ) : (
                                                    <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                                  ))}
                                              </span>
                                            </label>
                                            {/* <div className="col-md-10">
                                            <div className="row d-flex pt-1">
                                              {this.state.smsGroupList?.map(
                                                (item, index) =>
                                                  item.count > 0 ? (
                                                    <li
                                                      className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                      style={{ width: "22em" }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        checked={item.isactive}
                                                        id={`checkbox-${item.id}`}
                                                        onChange={(e) =>
                                                          this.onGroupClicked(
                                                            e,
                                                            item.id
                                                          )
                                                        }
                                                        style={{
                                                          alignSelf: "center",
                                                          marginRight: 5,
                                                          marginTop: "1px",
                                                          height: "12px",
                                                          width: "12px",
                                                        }}
                                                      />
                                                      &nbsp;
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                          cursor: "pointer",
                                                          color: this.state.smsGroupsId?.includes(item.id) ?
                                                            "#337AB7" : "#697a8d",
                                                        }}
                                                        onClick={() =>
                                                          document
                                                            .getElementById(
                                                              `checkbox-${item.id}`
                                                            )
                                                            .click()
                                                        }
                                                      >
                                                        {item?.name}
                                                      </span>
                                                      <span
                                                        className="ms-2"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: this.state.smsGroupsId?.includes(item.id) ?
                                                            "#337AB7" : "#697a8d",
                                                          fontWeight: "600",
                                                        }}
                                                        onClick={this.toGroupDetails.bind(
                                                          this,
                                                          item
                                                        )}
                                                      >
                                                        {"(" + item.count + ")"}
                                                      </span>
                                                    </li>
                                                  ) : (
                                                    <li
                                                      className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                      style={{
                                                        width: "22em",
                                                        color: "#cccccc",
                                                      }}
                                                    >
                                                      <input
                                                        disabled
                                                        type="checkbox"
                                                        checked={item.isactive}
                                                        style={{
                                                          alignSelf: "center",
                                                          marginRight: 5,
                                                          marginTop: "1px",
                                                          height: "12px",
                                                          width: "12px",
                                                        }}
                                                      />
                                                      &nbsp;
                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                        }}
                                                      >
                                                        {item?.name}
                                                      </span>
                                                      <span
                                                        className="ms-2"
                                                        style={{
                                                          color: "#cccccc",
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {"(" + item.count + ")"}
                                                      </span>
                                                    </li>
                                                  )
                                              )}
                                            </div>
                                          </div> */}
                                            <div className="col-md-10 ps-0">
                                              <div className="pt-1 prev-container">
                                                {this.state.smsGroupList?.map((item) =>
                                                  item.count > 0 ? (
                                                    <li
                                                      key={item.id}
                                                      className="list-group-item border-0 prev pt-0 pb-0 d-flex"
                                                      style={{
                                                        width: "22em",
                                                        breakInside: "avoid",
                                                      }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        checked={item.isactive}
                                                        id={`checkbox-${item.id}`}
                                                        onChange={(e) => this.onGroupClicked(e, item.id)}
                                                        style={{
                                                          alignSelf: "center",
                                                          marginRight: 5,
                                                          marginTop: "1px",
                                                          height: "12px",
                                                          width: "12px",
                                                        }}
                                                      />

                                                      <span
                                                        style={{
                                                          display: "inline-block",
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow: "ellipsis",
                                                          cursor: "pointer",
                                                          color: this.state.smsGroupsId?.includes(item.id)
                                                            ? "#337AB7"
                                                            : "#697a8d",
                                                        }}
                                                        onClick={() =>
                                                          document
                                                            .getElementById(`checkbox-${item.id}`)
                                                            .click()
                                                        }
                                                      >
                                                        {item?.name}
                                                      </span>

                                                      <span
                                                        className="ms-2"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: this.state.smsGroupsId?.includes(item.id)
                                                            ? "#337AB7"
                                                            : "#697a8d",
                                                          fontWeight: "600",
                                                        }}
                                                        onClick={() => this.toGroupDetails(item)}
                                                      >
                                                        {"(" + item.count + ")"}
                                                      </span>
                                                    </li>
                                                  ) : null
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          {this.state.smsActivityList.length >
                                            0 && (
                                              <div
                                                className="row d-flex pt-2 pb-2"
                                                style={{
                                                  borderTop: "2px solid #d3d0d0d5",
                                                }}
                                              >
                                                {/* Header with Expand/Collapse */}

                                                <label
                                                  className="col-sm-2 col-form-label fw-bold ps-3 d-flex flex-column align-self-start pe-0"
                                                  htmlFor="exampleFormControlTextarea1"
                                                >
                                                  <div className="d-flex align-items-center">
                                                    <span
                                                      className="cursor-pointer"
                                                      onClick={() =>
                                                        this.handleSortActivityList(
                                                          "messageName"
                                                        )
                                                      }
                                                    >
                                                      By Previous Msg
                                                      {(this.state.sortMsgColumn ===
                                                        "messageName" && this.state.showPreviousMsg) &&
                                                        (this.state
                                                          .sortMsgDirection ===
                                                          "asc" ? (
                                                          <i
                                                            className="fa fa-long-arrow-up ps-1"
                                                            aria-hidden="true"
                                                          ></i>
                                                        ) : (
                                                          <i className="fa-solid fa-arrow-down-long ps-1"></i>
                                                        ))}
                                                    </span>

                                                    <IconButton
                                                      className="cursor-pointer"
                                                      size="small"
                                                      onClick={this.togglePreviousMsg}
                                                      style={{ marginLeft: "4px" }}
                                                    >
                                                      {this.state.showPreviousMsg ? (
                                                        <ExpandLess fontSize="small" />
                                                      ) : (
                                                        <ExpandMore fontSize="small" />
                                                      )}
                                                    </IconButton>
                                                  </div>
                                                  {this.state.showPreviousMsg && (
                                                    <div className="mt-2 d-flex align-items-center">
                                                      <input
                                                        type="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        checked={
                                                          this.state.filterByKeyword
                                                        }
                                                        onChange={() =>
                                                          this.setState({
                                                            filterByKeyword:
                                                              !this.state
                                                                .filterByKeyword,
                                                          })
                                                        }
                                                      />
                                                      <p
                                                        className="form-label mb-0 ms-2 fw-normal"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                          this.setState({
                                                            filterByKeyword:
                                                              !this.state
                                                                .filterByKeyword,
                                                          })
                                                        }
                                                      >
                                                        By Keyword
                                                      </p>
                                                    </div>
                                                  )}
                                                </label>
                                                {/* Collapsible Section */}
                                                {this.state.showPreviousMsg && (
                                                  <div className="col-md-10 ps-0">
                                                    <div className="pt-1 prev-container">
                                                      {(this.state.filterByKeyword
                                                        ? this.state.smsActivityList?.filter(
                                                          (x) => x.messageKeyword !== ""
                                                        )
                                                        : this.state.smsActivityList
                                                      )?.map((item) => {
                                                        const itemLabel = this.state.filterByKeyword
                                                          ? `${item.messageKeyword} (${item.messageName})`
                                                          : `${item.messageName} ${item.messageKeyword ? `(${item.messageKeyword})` : ""
                                                          }`;

                                                        const isActive = this.state.activitieIds?.includes(item.id);

                                                        if (!this.state.filterByKeyword && item.activeContacts <= 0) {
                                                          return (
                                                            <li
                                                              key={item.id}
                                                              className="list-group-item border-0 prev pt-0 pb-0 d-flex"
                                                              style={{
                                                                width: "100%",
                                                                breakInside: "avoid",
                                                                color: "#cccccc",
                                                              }}
                                                            >
                                                              <input
                                                                type="checkbox"
                                                                checked={item.isactive}
                                                                disabled
                                                                style={{
                                                                  alignSelf: "center",
                                                                  marginRight: 5,
                                                                  marginTop: "1px",
                                                                  height: "12px",
                                                                  width: "12px",
                                                                }}
                                                              />

                                                              <span
                                                                style={{
                                                                  display: "inline-block",
                                                                  whiteSpace: "nowrap",
                                                                  overflow: "hidden",
                                                                  textOverflow: "ellipsis",
                                                                }}
                                                              >
                                                                {itemLabel}
                                                              </span>

                                                              <span
                                                                className="ms-2"
                                                                style={{
                                                                  color: "#cccccc",
                                                                  fontWeight: "600",
                                                                }}
                                                              >
                                                                ({item.activeContacts})
                                                              </span>
                                                            </li>
                                                          );
                                                        }

                                                        return (
                                                          <Tooltip
                                                            arrow
                                                            key={item.id}
                                                            title={
                                                              item.messageKeyword !== ""
                                                                ? `Keyword: ${item.messageKeyword}`
                                                                : ""
                                                            }
                                                            classes={{
                                                              popper: "custom-tooltip",
                                                            }}
                                                          >
                                                            <li
                                                              className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                              style={{
                                                                width: "100%",
                                                                breakInside: "avoid",
                                                              }}
                                                            >
                                                              <input
                                                                type="checkbox"
                                                                checked={item.isactive}
                                                                id={`checkbox-${item.id}`}
                                                                onChange={(e) =>
                                                                  this.onActivityClicked(e, item.id)
                                                                }
                                                                style={{
                                                                  alignSelf: "center",
                                                                  marginRight: 5,
                                                                  marginTop: "1px",
                                                                  height: "12px",
                                                                  width: "12px",
                                                                }}
                                                              />

                                                              <span
                                                                style={{
                                                                  display: "inline-block",
                                                                  whiteSpace: "nowrap",
                                                                  overflow: "hidden",
                                                                  textOverflow: "ellipsis",
                                                                  cursor: "pointer",
                                                                  color: isActive ? "#337AB7" : "#697a8d",
                                                                }}
                                                                onClick={() =>
                                                                  document
                                                                    .getElementById(`checkbox-${item.id}`)
                                                                    .click()
                                                                }
                                                              >
                                                                {itemLabel}
                                                              </span>

                                                              <span
                                                                className="ms-2"
                                                                style={{
                                                                  cursor: "pointer",
                                                                  color: isActive ? "#337AB7" : "#697a8d",
                                                                  fontWeight: "600",
                                                                }}
                                                                onClick={() =>
                                                                  this.toActivityDetails(item)
                                                                }
                                                              >
                                                                ({item.activeContacts})
                                                              </span>
                                                            </li>
                                                          </Tooltip>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                        </>
                                        {this.state.lastActivity !== "None" && (
                                          <div className="row" style={{
                                            borderTop: "2px solid #d3d0d0d5",
                                          }}>
                                            <div className="col-sm-2"></div>
                                            <div className="col-sm-10 ps-0">
                                              <li
                                                className="list-group-item list-group-item-action border-0 prev d-flex pb-0"
                                                style={{
                                                  color: "black",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={this.state.avoidRepeatSend}
                                                  onChange={(e) =>
                                                    this.avoidRepeatSendMessages(e)
                                                  }
                                                  style={{
                                                    alignSelf: "center",
                                                    marginRight: 5,
                                                    marginTop: "1px",
                                                    height: "12px",
                                                    width: "12px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                                &nbsp;
                                                <p
                                                  className="fw-normal m-0"
                                                  htmlFor="basic-default-supplierType"
                                                  id="givbeeText"
                                                >
                                                  Do not send this message to the
                                                  numbers it was sent to before.
                                                </p>
                                              </li>
                                              {/* <p
                                            className="fw-normal m-0 mt-2"
                                            htmlFor="basic-default-supplierType"
                                            id="givbeeText"
                                            style={{ paddingLeft: "32px" }}
                                          >
                                            *Messages are sent to each selected
                                            recipient just once.
                                          </p> */}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="p-3 pt-1">
                              <div className="col-md-12">
                                <div className="row d-flex">
                                  <label
                                    className="col-sm-2 col-form-label fw-bold pt-0 ps-0"
                                    htmlFor="basic-default-supplierType"
                                    id="assetFormLabel"
                                  >
                                    Schedule/Send
                                  </label>

                                  <div
                                    className="col-sm-10 ps-1"
                                    id="assetFormLabel"
                                  >
                                    <div className="row">
                                      <div class="col-sm-2 form-check form-check-inline">
                                        <FormControlLabel
                                          id="givbeeText"
                                          control={
                                            <Radio
                                              checked={this.state.sendNow}
                                              onChange={this.handleSendNowChange.bind(
                                                this
                                              )}
                                              value="now"
                                              name="inlineRadioOptions"
                                              inputProps={{ "aria-label": "Now" }}
                                              sx={{
                                                cursor: "pointer",
                                                p: 0,
                                                "& .MuiSvgIcon-root": {
                                                  fontSize: 16, // 
                                                },
                                              }}
                                            />
                                          }
                                          label="Now"
                                          sx={{
                                            margin: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            "& .MuiFormControlLabel-label": {
                                              fontSize: "0.9375rem",
                                              lineHeight: 1,
                                              paddingLeft: "4px",
                                            },
                                          }}
                                        />
                                      </div>
                                      <div className="col-sm-10"></div>
                                    </div>
                                    <div
                                      className="row d-flex mb-2"
                                      style={{ height: "45px" }}
                                      id="assetFormLabel"
                                    >
                                      <div class="col-sm-1 form-check align-self-center pe-0 mt-2 align-content-center">
                                        <FormControlLabel
                                          id="givbeeText"
                                          control={
                                            <Radio
                                              checked={this.state.ScheduledToSend}
                                              onChange={this.handleScheduledToSendChange.bind(
                                                this
                                              )}
                                              value="now"
                                              name="inlineRadioOptions"
                                              inputProps={{ "aria-label": "Now" }}
                                              sx={{
                                                cursor: "pointer",
                                                p: 0,
                                                "& .MuiSvgIcon-root": {
                                                  fontSize: 16, // 
                                                },
                                              }}
                                            />
                                          }
                                          label="Later"
                                          sx={{
                                            margin: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            "& .MuiFormControlLabel-label": {
                                              fontSize: "0.9375rem",
                                              lineHeight: 1,
                                              paddingLeft: "4px",
                                            },
                                          }}
                                        />

                                      </div>
                                      <div className="col-sm-10 pe-0 align-self-end">
                                        {this.state.ScheduledToSend && (
                                          <>
                                            <div className="row d-flex">
                                              <div className="col-sm-6 d-flex">
                                                <PtsDateTimePicker
                                                  value={
                                                    this.state.scheduledDateTime
                                                  }
                                                  onChange={this.handleScheduledDateTimeChange.bind(
                                                    this
                                                  )}
                                                />
                                              </div>
                                              <div className="col-sm-6 align-self-center ps-0">
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "#337AB7",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                  onClick={this.navigateOrgTimeZone.bind(
                                                    this
                                                  )}
                                                >
                                                  {this.businessDomain === BUSINESS_DOMAIN.eventText ? this.eventTimeZone?.displayText : this.orgTimeZone?.displayText}
                                                </span>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    <div className="row d-flex">
                                      <label
                                        className="col-sm-2 col-form-label fw-bold pt-0 ps-0"
                                        htmlFor="basic-default-supplierType"
                                        id="assetFormLabel"
                                      >
                                      </label>

                                      <div className="col-sm-10 align-self-end">
                                        <div className="row d-flex mt-2">
                                          {this.state.scheduleErrorMessage && (
                                            <>
                                              <div
                                                className="col-sm-12"
                                                id="assetFormLabel"
                                              >
                                                <div
                                                  className="row"
                                                  style={{ minHeight: "60px" }}
                                                >
                                                  <div className="col-sm-5 align-self-center">
                                                    <div class="form-check form-check-inline d-flex ps-2 m-0">
                                                      <input
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        type="checkbox"
                                                        name="inlineCheckboxOptions"
                                                        id="inlineCheckbox"
                                                        checked={this.state.sendReminder}
                                                        value={this.state.sendReminder}
                                                        onChange={this.handleSendReminderChange.bind(
                                                          this
                                                        )}
                                                      />
                                                      <label
                                                        class="form-check-label fw-bold ms-2"
                                                        htmlFor="inlineRadio1"
                                                      >
                                                        Send me a reminder 24 hrs before the
                                                        text is sent.
                                                      </label>
                                                    </div>
                                                  </div>
                                                  {this.state.sendReminder && (
                                                    <>
                                                      <div className="col-sm-3">
                                                        <div className="row">
                                                          <div className="col-sm-12">
                                                            <label
                                                              className="form-check-label"
                                                              id="givbeeText"
                                                            >
                                                              Mobile
                                                            </label>
                                                            <span className="d-flex sendMsgPhoneInput">
                                                              <input
                                                                type="text"
                                                                autoComplete="off"
                                                                name="multiStepsFirstName"
                                                                className="form-control"
                                                                required={
                                                                  this.state.reminderEmail ===
                                                                  ""
                                                                }
                                                                value={
                                                                  this.state.reminderMobileNo
                                                                }
                                                                onChange={this.handleReminderMobileNoChange.bind(
                                                                  this
                                                                )}
                                                                validators={["required"]}
                                                                errormessages={[
                                                                  "This field is required",
                                                                ]}
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-sm-3">
                                                        <div className="row">
                                                          <div className="col-sm-12">
                                                            <label
                                                              className="form-check-label"
                                                              id="givbeeText"
                                                            >
                                                              Email
                                                            </label>

                                                            <input
                                                              required={
                                                                this.state
                                                                  .reminderMobileNo === ""
                                                              }
                                                              type="email"
                                                              autoComplete="off"
                                                              id="multiStepsFirstName"
                                                              name="multiStepsFirstName"
                                                              className="form-control"
                                                              value={this.state.reminderEmail}
                                                              onChange={this.handleReminderEmailChange.bind(
                                                                this
                                                              )}
                                                              validators={["required"]}
                                                              errormessages={[
                                                                "This field is required",
                                                              ]}
                                                            />
                                                          </div>
                                                          {/* {this.state.reminderErrorMessage ? (
                                              <lable
                                                className="danger mt-2"
                                                style={{
                                                  color: "red",
                                                }}
                                              >
                                                Please enter either mobile phone
                                                or email address.
                                              </lable>
                                            ) : (
                                              ""
                                            )} */}
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
                <div className="row p-2 d-flex">
                  <div className="col-sm-2 ps-1">
                    <BackButton
                      type="button"
                      style={{
                        backgroundColor: "#162c50",
                        color: "#fff",
                      }}
                      variant="contained"
                      onClick={(e) => this.viewCancel()}
                    >
                      Back
                    </BackButton>
                  </div>
                  <div className="col-sm-8 text-center justify-content-center">
                    {this.state.ScheduledToSend ? (
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={this.isScheduledSendDisabled()}
                        style={{
                          padding: "10px",
                          background: "#37517e",
                          color: "#fff",
                          fontSize: "18px",
                          fontWeight: "600",
                          width: "130px",
                          textTransform: "capitalize",
                          opacity: this.isScheduledSendDisabled() ? 0.6 : 1,
                          cursor: this.isScheduledSendDisabled() ? "not-allowed" : "pointer",

                        }}
                      >
                        Schedule Send
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={this.isSendDisabled()}
                        style={{
                          padding: "10px",
                          background: "#37517e",
                          color: "#fff",
                          fontSize: "18px",
                          fontWeight: "600",
                          width: "80px",
                          textTransform: "capitalize",
                          opacity: this.isSendDisabled() ? 0.6 : 1,
                          cursor: this.isSendDisabled() ? "not-allowed" : "pointer",
                        }}
                      >
                        Send
                      </Button>
                    )}
                  </div>
                </div>
              </ValidatorForm>
            }
          </>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p style={{ fontSize: "16px" }}>
                  The texting window for this event begins on{" "}
                  <b>{this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(this.state.event?.startDate) : Utils.getUtcToLocal(this.state.event?.startDate)}</b>. To test this message now, please use the "Send Test" feature.
                </p>
              </span>
            </DialogContent>
          </Dialog>
          <Dialog
            open={this.state.tollfreeNumberNotApprove}
            onClose={this.handleClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "16px" }}>
                  Toll free number is not approved.
                </p>
              </span>
            </DialogContent>
          </Dialog>
          <Dialog
            open={this.state.openTextingTimeWindow}
            onClose={this.handleTextingTimeWindowClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p style={{ fontSize: "16px" }}>
                  {`Texts can only be sent between the hours of ${Utils.formatTimeToAMPM(this.organization?.textingWindowStart)} and ${Utils.formatTimeToAMPM(this.organization?.textingWindowEnd)}. In the case of an emergency, Admin user may`}
                  <span
                    className="anchortag ps-1"
                    onClick={() => this.organizationInfo()}
                  >
                    override the setting here.
                  </span>
                </p>
              </span>
            </DialogContent>
          </Dialog>
        </>
      );
    }
  }
}
export default withRouter(PreviewAndSend);
